import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/chats/client.tsx");
